import { useContext } from "react";
import { AppStoreContext } from "contexts/AppStoreContext";

export const useAppStore = () => useContext(AppStoreContext);
